function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoSurfercloud(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#2E85FF",
    d: "M10.122 11.045s0 .002-.002.003a13.094 13.094 0 01-2.679 2.947 13.389 13.389 0 01-3.049 1.856l-.038.017a13.273 13.273 0 01-1.172.447 2.078 2.078 0 01-1.474-.184 2.004 2.004 0 01-.708-.63c.254.06.524.074.799.033.966-.146 1.664-.928 1.705-1.834a1.832 1.832 0 00-.003-.217c.005-.267.04-.528.102-.78.2-.81.681-1.529 1.353-2.04a3.876 3.876 0 011.796-.746 3.906 3.906 0 013.365 1.128h.005m12.341 1.325c-.008.1-.039.318-.137.648a7.943 7.943 0 00-.128-.12l.004-.011c-.552-.485-1.23-.772-1.964-.772-.973 0-1.845.501-2.454 1.3l-.036.06c-.037.064-.075.129-.114.192a15.4 15.4 0 001.27-3.767 3.15 3.15 0 01.34-.023c.018-.002.036-.002.053-.002.5 0 .974.11 1.396.31a3.143 3.143 0 011.124.87c.005.007.009.014.014.019.303.373.526.813.632 1.296"
  }), React.createElement("path", {
    fill: "#A0C6FC",
    d: "M22.463 11.389c0 .299-.014.596-.044.887a3.273 3.273 0 00-.66-1.353l-.015-.019a3.28 3.28 0 00-1.172-.909 3.382 3.382 0 00-1.457-.324c-.019 0-.037 0-.056.002a3.377 3.377 0 00-3.062 2.026 13.222 13.222 0 01-.8 1.503 14.12 14.12 0 01-2.564 3.102c-.52.474-1.076.909-1.663 1.306a14.8 14.8 0 01-6.214.113c.489-.22.96-.468 1.418-.74 2.696-1.606 4.81-4.057 5.96-6.979.116-.293.222-.59.317-.892.41-.99.998-1.891 1.725-2.666v-.001A4.538 4.538 0 0117.507 5c1.682 0 3.15.905 3.921 2.248a9.34 9.34 0 01.257.521c.27.598.476 1.23.606 1.887.113.56.172 1.139.172 1.733"
  }), React.createElement("path", {
    fill: "#A0C6FC",
    d: "M23 15.657c-1.161-.909-2.102-.196-2.513.24a5.674 5.674 0 01-1.194 1.15 5.117 5.117 0 01-1.915.834 4.939 4.939 0 01-.847.098c.001.006.005.013.009.021h-3.735a11.58 11.58 0 001.09-.703 12.283 12.283 0 001.928-1.753c.303-.343.592-.704.861-1.083l.026-.036v-.002c.088-.123.174-.248.256-.375.04-.06.079-.12.117-.181l.037-.056c.625-.755 1.521-1.228 2.52-1.228.754 0 1.45.27 2.017.728-.001.004-.001.009-.003.012A3.874 3.874 0 0123 15.657"
  })));
}

SvgLogoSurfercloud.clsName = 'icon-uc-social__logo-surfercloud';
SvgLogoSurfercloud.remarkName = 'unknown';
export default SvgLogoSurfercloud;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoSurfercloud.js
// module id = 2256
// module chunks = 17 18